import axios from 'axios';

 const SERVER = process.env.REACT_APP_SERVER || "http://localhost:4000/";

 console.log(SERVER);

/** Origem da API (sem barra final), útil para URLs estáticas ex.: /uploads */
export const API_ORIGIN = SERVER.replace(/\/$/, "");

const server = axios.create({
    baseURL: SERVER,
    timeout: 50000,
    timeoutErrorMessage: 'Servidor Instável. Tente mais tarde.',
    withCredentials: true, // Importante para enviar cookies
});

// Interceptor de requisição - não precisa adicionar token manualmente
// pois o backend gerencia via cookies httpOnly
server.interceptors.request.use(async config => {
    return config;
});

// Interceptor de resposta para tratar erros de autenticação
server.interceptors.response.use(
    response => response,
    async error => {
        // Removido o redirecionamento automático que causava loop
        // O controle de navegação deve ser feito pelos componentes React
        // if (error.response?.status === 401) {
        //     window.location.href = '/';
        // }
        throw error;
    },
);

export default server;
